import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldOperatorDropdown } from '@/(routers)/boards/editor/block/definitions/fields/fieldOperatorDropdown';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';
import { READ_MODE_OPTIONS } from '@/(routers)/boards/editor/block/generators/arduino/blocks/sensing/helper/analog_helper';

const POSITION_OPTIONS = {
    orange: {
        rectColour: CATEGORIES.sensing.color,
        options: [
            { value: 'UPPER_LEFT', label: '左上' },
            { value: 'UPPER_RIGHT', label: '右上' },
        ],
    },
    blue: {
        rectColour: CATEGORIES.sensing.color,
        options: [
            { value: 'UPPER_LEFT', label: '左上' },
            { value: 'UPPER_RIGHT', label: '右上' },
            { value: 'LOWER_LEFT', label: '左下' },
            { value: 'LOWER_RIGHT', label: '右下' },
        ],
    },
} as const;

defineBlock({
    type: 'sound',
    colour: CATEGORIES.sensing.color,
    textColour: '#FFFFFF',
    tooltip: '音センサーの値を読み取ります',
    movable: true,
    deletable: true,
    output: 'Number',
    inputs: [
        {
            kind: 'dummy',
            fields: [
                { type: 'image', icon: { src: '/images/block/sound.svg', size: 65 } },
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('音センサー', { fontSize: 15, fontWeight: 'bold' }),
                },
                { type: 'label', text: ' ' },
                {
                    type: 'dropdown',
                    name: 'POSITION',
                    rectColour: POSITION_OPTIONS.orange.rectColour,
                    options: [...POSITION_OPTIONS.orange.options],
                },
                { type: 'label', text: 'で' },
                {
                    type: 'dropdown',
                    name: 'READ_MODE',
                    rectColour: POSITION_OPTIONS.orange.rectColour,
                    options: READ_MODE_OPTIONS,
                },
                { type: 'label', text: 'を計測する ' },
            ],
        },
    ],
    onBoardChange: (block, board) => {
        const field = block.getField('POSITION') as FieldOperatorDropdown | null;
        if (!field) return;
        field.setOptions([...POSITION_OPTIONS[board].options]);
    },
});
